// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  list-style: none;\n  padding: 0px;\n}\n.modal-list .modal-item {\n  text-align: center;\n  cursor: pointer;\n}\n.modal-content {\n  width: auto;\n}\n.selected {\n  border: 1px solid;\n}", ""]);
// Exports
module.exports = exports;
